import { render, staticRenderFns } from "./FamilyHubAppLink.vue?vue&type=template&id=42db910e"
import script from "./FamilyHubAppLink.vue?vue&type=script&lang=js"
export * from "./FamilyHubAppLink.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports